import { AutoCompletePropertiesType } from "@website/ui-old/auto-complete/auto-complete.types";

/**
 * @deprecated please use @website/ui instead
 */
export const useSwap = (properties: AutoCompletePropertiesType) => {
  const { onSwap } = properties;

  return {
    swapButtonProperties: {
      onClick: onSwap
    }
  };
};
